import React, { useState } from "react";
import { Authenticated, Unauthenticated } from "convex/react";
import { LandingPage } from "../components/landingPage/LandingPage";
import { SignInForm } from "../components/SignInForm";
import { Dashboard } from "../components/Dashboard";
import { Sidebar } from "../components/Sidebar";
import { Account } from "./Account";
import { FirstTimePricingPopup } from "../components/modals/FirstTimePricingPopup";

type Page = "home" | "account";

export function Home() {
  const [showAuth, setShowAuth] = useState(false);
  const [currentPage, setCurrentPage] = useState<Page>("home");

  return (
    <>
      <Unauthenticated>
        {showAuth ? (
          <div className="h-screen flex">
            {/* Left Side - Branding */}
            <div className="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-orange-500 via-orange-400 to-orange-600 relative overflow-hidden">
              <div className="absolute inset-0 bg-black/10"></div>
              <div className="relative z-10 flex flex-col justify-center items-center p-12 text-white">
                <div className="mb-8">
                  <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center mb-6">
                    <span className="text-3xl font-bold text-white">R</span>
                  </div>
                  <h1 className="text-5xl font-bold mb-4">reelcat</h1>
                  <p className="text-xl text-white/90 max-w-md">
                    Create viral shorts in seconds with AI-powered video editing
                  </p>
                </div>
                <div className="mt-12 space-y-4">
                  <div className="flex items-center gap-3 text-white/80">
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span>AI-powered editing</span>
                  </div>
                  <div className="flex items-center gap-3 text-white/80">
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span>From raw footage to viral shorts in 3 clicks</span>
                  </div>
                  <div className="flex items-center gap-3 text-white/80">
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span>Trusted by over 3 million users</span>
                  </div>
                </div>
              </div>
              {/* Decorative elements */}
              <div className="absolute top-0 right-0 w-96 h-96 bg-white/5 rounded-full blur-3xl"></div>
              <div className="absolute bottom-0 left-0 w-96 h-96 bg-white/5 rounded-full blur-3xl"></div>
            </div>

            {/* Right Side - Login Form */}
            <div className="w-full lg:w-1/2 flex items-center justify-center bg-background p-8">
              <div className="w-full max-w-md">
                <button
                  onClick={() => setShowAuth(false)}
                  className="mb-8 flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                  </svg>
                  <span className="text-sm font-medium">Back to home</span>
                </button>
                
                <div className="mb-6">
                  <h1 className="text-3xl font-bold text-foreground mb-2">Welcome to reelcat</h1>
                  <p className="text-muted-foreground">Sign in to your account or create a new one to get started</p>
                </div>

                <SignInForm />
              </div>
            </div>
          </div>
        ) : (
          <div className="w-full">
            <LandingPage
              onLoginClick={() => setShowAuth(true)}
              onTryFreeClick={() => setShowAuth(true)}
            />
          </div>
        )}
      </Unauthenticated>

      <Authenticated>
        <div className="flex h-screen bg-muted overflow-hidden">
          {/* Sidebar */}
          <Sidebar currentPage={currentPage} setCurrentPage={setCurrentPage} />

          {/* Main Content */}
          <div className="flex-1 flex flex-col min-h-0 overflow-hidden">
            <main className="flex-1 overflow-y-auto overflow-x-hidden min-h-0">
              {currentPage === "home" && <Dashboard />}
              {currentPage === "account" && <Account />}
            </main>
          </div>
        </div>

        {/* First Time Pricing Popup */}
        <FirstTimePricingPopup />
      </Authenticated>
    </>
  );
}
